import Vue from 'vue';
import config from '@/config.json';
import { PROXY_STAND } from '../../config/proxy';

// Bind Vue
Object.assign(config, { PROXY_STAND });
Vue.$app = config;
Object.defineProperty(Vue.prototype, '$app', {
  get() {
    return config;
  },
});
